<template>
  <info-header-card :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import TestProcessModel from "@/models/lab/TestProcessModel";

export default {
  name: "TestProcessCard",
  components: {
    InfoHeaderCard
  },
  props: {
    test_process: {
      type: Object,
      default: () => new TestProcessModel()
    }
  },
  computed: {
    header() {
      return this.test_process.name;
    },
    rows() {
      const sample_types = this.test_process.getSampleTypes();
      const sample_type_names = sample_types.models.length
        ? sample_types.models
            .map(({ name }) => name)
            .sort()
            .join(", ")
        : null;

      return [
        {
          label: "Sample Types",
          value: sample_type_names
        },
        {
          label: "Description",
          value: this.test_process.description
        }
      ];
    }
  }
};
</script>
